var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.hideSearchTip}},[_c('layout-header'),_c('div',[_c('router-view')],1),(_vm.shouldShowImDialog)?_c('imDialog'):_vm._e(),(_vm.showFooter)?_c('layout-footer'):_vm._e(),_c('login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }